import React from 'react';
import { ShowAlert } from '../../Components/ShowAlert';

interface DocuSignState {
    event: string;

}

class DocusignCallBack extends React.Component<{}, DocuSignState> {

    constructor(_props: any) {
        super(_props);
        this.state = {
            event: ''
        }
    }
    componentDidMount() {
        // Access the full URL (href) when the component is mounted
        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);

        // Get specific query parameters
        this.setState({ event: params.get('event') || '' }, () => {
            let isCompleted = this.state.event.toLowerCase() === 'signing_complete';
            let title = isCompleted ? 'Success' : 'Failure';
            let message = isCompleted ? 'Signing Completed, the document will get submitted to the IRS' : 'Signing Failed, the form needs to be submitted again';
            let type = isCompleted ? 'success' : 'failure';

            ShowAlert(title, message, type).then(r => {

                window.location.href = `/processCompleted`;

            });
        });
    }

    public render() {



        //  this.state.event.toLowerCase() !== 'signing_complete' && ShowAlert("Failure", "Signing Failed, the form needs to be submitted again", "success").then((r=> {
        //     window.location.href = `/processCompleted`;
        //  }));
        return <></>;
    }
}
export default DocusignCallBack;
